import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ip } from 'src/app/constant/constant';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { MapService } from 'src/app/services/map.service';
import { ToastService } from 'src/app/services/toast.service';
import { InviteConfirmationModalComponent } from '../confirmation-modal/invite-confirmation-modal.component';
import { SubscriptionStatus } from 'src/app/pages/subscription/models/subscription-usage.model';

@Component({
    selector: 'app-invitation-model',
    templateUrl: './invitation-model.component.html',
    styleUrls: ['./invitation-model.component.scss'],
    standalone: false
})
export class InvitationAcceptRejectModalComponent implements OnInit {
  @Output() statusUpdated = new EventEmitter<string>();
  @Input() userId: any;
  @Input() invitationId: any;
  @Input() pre_accepted_character_id: any;
  playerLevel: any;
  game_system: any;
  invitationdetail: any;
  imageurl = ip
  selectedCharacterid: any;
  characterList: any = [];
  char_id: any;
  characternullerror: any;
  startlocation: any;
  invitationForm: FormGroup;
  map_id: any;
  culture: any = "";
  isSubmitting = false;
  isUserCanCreateChar: boolean
  private pointSubscription: Subscription;
  planUsage: SubscriptionStatus
  constructor(public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private dataserv: DataService, private router: Router,
    private mapService: MapService, private elementRef: ElementRef,
    private formBuilder: FormBuilder,
    private coordinatesService: CoordinatesService,
    private modalService: NgbModal,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef
  ) {
    this.invitationForm = this.formBuilder.group({
      charOption: [{}, Validators.required],

    })
    // this.pointSubscription = this.coordinatesService.pointDrawn$.subscribe((coordinates) => {

    //   this.startlocation = coordinates;
    //   const url = this.mapService.getFeatureinfo(3, coordinates)
    //   fetch(url).then((res) => { return res.text(); }).then(res => {
    //     const feature = JSON.parse(res)['features'];

    //     this.culture = feature.length > 0 ? feature[0].properties.name : "";
    //     if (this.culture?.length > 0) {
    //       this.invitationForm.get("culture").setValue(this.culture)
    //       this.invitationForm.updateValueAndValidity()
    //     }
    //     else {
    //       this.toastService.showSuccess('Culture Not Avaliable at drop location', 'danger')
    //     }
    //   })
    // });


  }

  ngOnInit(): void {
    const userId = this.userId; // Accessing user_id parameter
    const invitationId = this.invitationId; // Accessing invitation_id parameter
    this.getinvitation(userId, invitationId)
    this.intializePlanUsage()
    // Accessing route parameters
  }

  ngOnDestroy(): void {
    this.pointSubscription?.unsubscribe();
    this.mapService.removeOldMap()
  }

  ngAfterViewInit(): void {
  }

  intializePlanUsage() {
    this.currentUserService.planUsageData.subscribe((data: SubscriptionStatus) => {
      this.planUsage = data;
      this.cdr.detectChanges();
    })
  }

  getinvitation(userId: any, invitationId: any) {
    this.dataserv.get_invitationdetail(userId, invitationId).subscribe((data: any) => {
      if (data) {
        this.invitationdetail = data.invitations
        this.char_id = this.invitationdetail[0].character_id
        this.map_id = this.invitationdetail[0].map_id
        this.getcharlist(this.char_id, this.map_id);
        this.cdr.detectChanges();
      }
    },
      (error) => {
        this.toastService.showSuccess(error.error.message, 'danger');
      
          this.cdr.detectChanges();})
  }

  getcharlist(char_id, map_id) {
    this.dataserv.Getcharacterdetail(this.userId, map_id).subscribe({
      next: (res: any) => {
        if (res && res.character_details && res.character_details.length > 0) {

          this.characterList = res.character_details.filter(character => character.nickname !== null);
          this.selectedCharacterid = char_id
          const invitedUser = this.characterList.find(invitation => invitation.id === char_id);
          this.invitationForm.get('charOption').setValue(invitedUser)
          if (this.pre_accepted_character_id) {
            this.selectAndAcceptAndReject(this.invitationdetail[0], 'ACCEPTED', { id: this.pre_accepted_character_id })
          }
        }
        else {
          if (this.isUserCanCreateChar) {
            this.openConfirmationModal(true)
          }
          else {
            this.openConfirmationModal(false);
          }
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toastService.showSuccess(error.error.message, 'danger');
      
          this.cdr.detectChanges();}
    })
  }



  addnewplayer(invitationId: string) {
    this.closeModal();
    if (this.isHaveCharQuota()) {
      this.router.navigate(['/player-detail', 'create'], { queryParams: { mode: 'create', map_code: this.map_id, playerLevel: this.playerLevel, game_system: this.game_system, fallbackToInvite: true, autoInviteId: invitationId } });
      localStorage.setItem('map_id', this.map_id)
    }
    else {
      this.openConfirmationModal(false);
    }
  }

  isHaveCharQuota(): boolean {
    if (this.planUsage.subscription_features.max_active_characters === -1) return true
    if (this.planUsage) {

      return this.planUsage.subscription_features.max_active_characters > this.planUsage.usage.characters_created;
    }
    return false;
  }

  navigateToSubscribe() {
    this.closeModal();
    this.router.navigate(['/subscription'], { queryParams: { isUser: true } });
  }

  openConfirmationModal(ishaveCharQuota: boolean) {
    this.activeModal.dismiss();
    const modalRef = this.modalService.open(InviteConfirmationModalComponent, {
      size: 'sm',
      backdrop: 'static',
      centered: true
    })

    modalRef.componentInstance.ishaveCharQuota = ishaveCharQuota
    modalRef.componentInstance.invitattionDetailInstance = this.invitationdetail[0]
    modalRef.componentInstance.map_id = this.map_id
    modalRef.componentInstance.pre_accepted_character_id = this.pre_accepted_character_id
    modalRef.result.then((result) => {
      if (result) {
        this.closeModal()
      }
    
          this.cdr.detectChanges();})

  }

  onOptionChange(character): void {
    this.pointSubscription = this.coordinatesService.pointDrawn$.subscribe((coordinates) => {
      this.startlocation = coordinates;
      // Do something with the coordinates, e.g., update the UI
    
          this.cdr.detectChanges();});
    if (!this.startlocation) {
      this.mapService?.addPointDrawInteraction(this.invitationForm.value.charOption, null)
      return
    }
    this.mapService?.addPointDrawInteraction(this.invitationForm.value.charOption !== null ? this.invitationForm.value.charOption : '/media/media/char_detail_imgs/spotonmap_25_Images.png', this.startlocation, 'Changed')

  }


  save(invitationdata: any, status: string) {

    if (this.isSubmitting) return;
    this.isSubmitting = true; // Prevent multiple clicks
    if (this.invitationForm.valid || status === 'REJECTED') {
      const data = {
        "id": invitationdata.id,
        "game_id": invitationdata.game_id,
        "status": status,
        "character_id": this.invitationForm.value.charOption ? Number(this.invitationForm.value.charOption.id) : null,
        "geography": this.startlocation?.join(),
        "culture": this.invitationForm?.value?.culture ? this.invitationForm?.value.culture : ''
      };

      this.dataserv.invitationdetailstatusupdate(data).subscribe((res) => {
        if (status === 'REJECTED') {
          this.toastService.showSuccess('Invitation declined.', 'success');
          this.statusUpdated.emit(status); // ✅ Emit status update
        } else {
          this.toastService.showSuccess('Invitation accepted.', 'success');
          this.statusUpdated.emit(status); // ✅ Emit status update
        }
        this.closeModal(); // ✅ Close modal after emitting
      
          this.cdr.detectChanges();}, (err) => {
        console.error('Error updating status:', err);
      
          this.cdr.detectChanges();});
    }
  }

  selectAndAcceptAndReject(invitationdata, status: string, charItem?) {


    if (charItem) {
      this.invitationForm.get('charOption').setValue(charItem);
    }
    if (this.isSubmitting) return;
    this.isSubmitting = true; // Prevent multiple clicks
    if (this.invitationForm.valid || status === 'REJECTED') {
      const data = {
        "id": invitationdata.id,
        "game_id": invitationdata.game_id,
        "status": status,
        "character_id": this.invitationForm.value.charOption ? Number(this.invitationForm.value.charOption.id) : null,
        "geography": this.startlocation?.join(),
        "culture": this.invitationForm?.value?.culture ? this.invitationForm?.value.culture : ''
      };

      this.dataserv.invitationdetailstatusupdate(data).subscribe((res) => {
        if (status === 'REJECTED') {
          this.toastService.showSuccess('Invitation declined.', 'success');
          this.statusUpdated.emit(status); // ✅ Emit status update
        } else {
          this.toastService.showSuccess('Invitation accepted.', 'success');
          this.statusUpdated.emit(status); // ✅ Emit status update
        }
        this.closeModal();
        this.handleCharacterModifyNavigation(charItem) // ✅ Close modal after emitting
      
          this.cdr.detectChanges();}, (err) => {
        console.error('Error updating status:', err);
      
          this.cdr.detectChanges();});
    }
  }

  handleCharacterModifyNavigation(characterInstance) {
    const playerId = characterInstance.id; // Make sure 'id' is a valid property of the 'data' object
    this.router.navigate(['/player-detail', playerId], {
      queryParams: { mode: 'edit', isPlay: true },
    });
  }

  closeModal() {
    // Closing the modal without triggering another API call
    this.activeModal.close();
  }


}
